import { useDispatch, useSelector } from 'react-redux'

import { postOrderConfirmation } from '@/api/shopApi'
import Button from '@/components/form/Button'
import ReactSelect from '@/components/form/ReactSelect'
import { Translation } from '@/components/i18n/Translation'
import {
  getIsCompleted,
  getSelectedAddressId,
  getTempOrderId,
  saveTempOrder,
  setIsCompleted,
  setSelectedAddressId,
} from '@/ducks/shopOrderReducer'
import { getAddresses } from '@/ducks/shopProductsReducer'
import { getIsOrderValid } from '@/ducks/shopProgressReducer'
import useApiCaller from '@/hooks/useApiCaller'

import './step-confirm.scss'

const StepConfirm = () => {
  const dispatch = useDispatch()
  const orderId = useSelector(getTempOrderId)
  const addresses = useSelector(getAddresses)
  const selectedAddressId = useSelector(getSelectedAddressId)
  const isCompleted = useSelector(getIsCompleted)
  const isOrderValid = useSelector(getIsOrderValid)

  const action = async () => {
    // @ts-ignore
    await dispatch(saveTempOrder())
    return await postOrderConfirmation(orderId)
  }
  // @ts-ignore
  const onSuccess = result => {
    const { ecomOrderId } = result
    dispatch(setIsCompleted(ecomOrderId))
  }

  const { callApi } = useApiCaller({
    // @ts-ignore
    action,
    // @ts-ignore
    onSuccess,
    loadingText: 'Completing order',
    successText: 'Order confirmed',
    errorText: 'Could not complete order',
  })
  // @ts-ignore
  const addressOptions = addresses.map(address => ({
    label: `${address.address}, ${address.zip} ${address.city}`,
    value: address.id,
  }))

  return (
    <div className="shop-step__confirm">
      <h2>
        <Translation id="Confirm order" />
      </h2>

      <p>
        <Translation id="Please review your product selection, choose a delivery address and confirm your order." />
      </p>

      <ReactSelect
        placeholder={<Translation id="Select delivery address" />}
        options={addressOptions}
        value={selectedAddressId}
        // @ts-ignore
        onChange={value => dispatch(setSelectedAddressId(value))}
        isDisabled={isCompleted}
      />

      <Button onClick={callApi} disabled={isCompleted || !isOrderValid}>
        <Translation id="Confirm order" />
      </Button>
    </div>
  )
}

export default StepConfirm
